import dayjs from 'dayjs';

export function getCycleName(pondName: string, registrationDate: dayjs.Dayjs): string {
  const formattedDate = registrationDate.format('DD/MM/YYYY');
  return `${pondName}_${formattedDate}`;
}